import cx from 'classnames'
import * as React from 'react'

import styles from './styles.css'

type Props = {
  className?: string
  children: React.ReactNode
}

const StepComponent = ({ children, className }: Props) => (
  <div className={cx(styles.content, className)}>{children}</div>
)

export default StepComponent
